import { useHistory } from 'react-router-dom'

import { Container } from './style'


export function Business({ business }) {
    const history = useHistory()

    return(
        <Container onClick={() => history.push('/menu/' + business.nameBusiness)}>

            <div className="image">
                <img 
                    src={business.linkProfile} 
                    alt={business.nameBusiness}
                    loading='lazy'
                />
                {business.isOpenBusiness ?
                    <></> :
                    <div>
                        <p>Fechado</p>
                    </div>
                }
            </div>

            <div className="text">
                <p className="name">{business.name}</p>
                <p className="sector">{business.sector}</p>
                <span>{business.minTimeDelivery} - {business.maxTimeDelivery} min</span>
            </div>
            
        </Container>
    )
}
